module.exports = __webpack_public_path__ + "img/22MinuteHardCorps.425e0f65.jpg";